module.exports = __webpack_public_path__ + "static/media/control-points-pic1.8b893eab.svg";